type StorageLocation = 'cloud' | 'device';

interface StorageConfirmDialogProps {
  isOpen: boolean;
  mode: 'move' | 'overwrite';
  from: StorageLocation;
  to: StorageLocation;
  onConfirm: () => void;
  onCancel: () => void;
}

function locationLabel(loc: StorageLocation, grammatical: 'nominative' | 'genitive'): string {
  if (loc === 'cloud') return grammatical === 'genitive' ? 'Chmury' : 'Chmura';
  return grammatical === 'genitive' ? 'Urządzenia' : 'Urządzenie';
}

export default function StorageConfirmDialog({
  isOpen,
  mode,
  from,
  to,
  onConfirm,
  onCancel,
}: StorageConfirmDialogProps) {
  if (!isOpen) return null;

  const message =
    mode === 'move'
      ? `Czy na pewno chcesz przenieść formularz z ${locationLabel(from, 'genitive')} do ${locationLabel(to, 'genitive')}?`
      : `Czy chcesz nadpisać formularz w ${locationLabel(from, 'genitive')}?`;

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 2000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '8px',
          padding: '28px',
          maxWidth: '420px',
          width: '90%',
          boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
        }}
      >
        <p style={{ fontSize: '16px', marginTop: 0, lineHeight: '1.5', color: '#333' }}>{message}</p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 20px', background: '#f5f5f5',
              border: '1px solid #ccc', borderRadius: '4px',
              cursor: 'pointer', fontSize: '14px',
            }}
          >
            Anuluj
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '10px 20px', background: '#4a90e2',
              color: 'white', border: 'none', borderRadius: '4px',
              cursor: 'pointer', fontSize: '14px',
            }}
          >
            Potwierdź
          </button>
        </div>
      </div>
    </div>
  );
}
